import React from 'react';
import { makeStyles, Box, Snackbar, Typography } from '@material-ui/core';
import ConfirmationIcon from '../../icons/confirmation-icon';

const styles = makeStyles(({ palette, spacing, notificationPadding }: any) => ({
  messageClass: {
    padding: `${spacing(3)}px ${spacing(5)}px`,
    width: '100%',
    '&>p': {
      ...notificationPadding,
    },
  },
  error: {
    backgroundColor: palette.error.main,
    color: palette.text.contrastText,
    '&>p': {
      marginBottom: spacing(2),
    },
  },
  success: {
    backgroundColor: palette.success.light,
    color: palette.background.dark,
    display: 'flex',
    alignItems: 'center',
    '&>p': {
      marginLeft: spacing(3),
    },
  },
}));

interface NotificationBannerProps {
  open: boolean;
  onClose?: () => void;
  messages?: string[];
  autoHideDuration?: number;
  variant?: 'error' | 'success';
}

const NotificationBanner = ({
  open,
  onClose,
  messages = [],
  variant = 'error',
  autoHideDuration = 0,
}: NotificationBannerProps) => {
  const classes = styles();

  return (
    <Snackbar
      autoHideDuration={autoHideDuration}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Box className={`${classes.messageClass} ${classes[variant]}`}>
        {variant === 'success' && <ConfirmationIcon size="small" />}
        {messages.map((message) => (
          <Typography variant="body2" color="inherit" key={message}>
            {message}
          </Typography>
        ))}
      </Box>
    </Snackbar>
  );
};

export default NotificationBanner;
